import { memo } from 'react';
import { ListItem, Text, UnorderedList, VStack } from '@chakra-ui/react';

// {
// 	text?: string[] | string,
// 	list?: {
// 		title: '',
// 		items: [],
// 	},
// },
const TextParserComponent = ({ content, textGap = '8px', paragraphGap = '32px', ...props }) => (
  <VStack gap={paragraphGap} w="full" align="start" fontSize="18px" {...props}>
    {content.map(({ text = null, list = null }, i) => (
      <VStack key={i} gap={textGap} w="full" align="start">
        {text &&
          (Array.isArray(text) ? (
            <>
              {text.map(stroke => (
                <CustomText key={stroke}>{stroke}</CustomText>
              ))}
            </>
          ) : (
            <CustomText>{text}</CustomText>
          ))}

        {list && (
          <VStack w="full" gap="4px" align="start">
            {list?.title && <CustomText>{list?.title}</CustomText>}

            <UnorderedList ps="42px">
              {list?.items?.map(stroke => (
                <CustomText as={ListItem} key={stroke}>
                  {stroke}
                </CustomText>
              ))}
            </UnorderedList>
          </VStack>
        )}
      </VStack>
    ))}
  </VStack>
);

export const TextParser = memo(TextParserComponent);

const CustomTextComponent = ({ children, ...props }) => (
  <Text
    textStyle="h4"
    fontSize={{ mobile: '16px', laptop: '20px' }}
    lineHeight={{ mobile: '140%', laptop: '124%' }}
    {...props}
  >
    {children}
  </Text>
);
const CustomText = memo(CustomTextComponent);
